import { Tag } from "../Tag";

export class Textarea extends Tag {
    public getText(): string {
        return this.getElement().value;
    }

    public clear(): this {
        this.getElement().value = "";
        return this;
    }

    public setText(value: any): void {
        this.getElement().value = value;
    }

    public getTagName() {
        return "textarea";
    }

    protected createSelf() {
        super.createSelf();
        this.getElement().textContent = this.get("v");
    }
}
